var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-avatar',{staticClass:"elevation-0 my-auto ml-auto",attrs:{"size":"22px","color":"#ff6c6c"}},[_c('span',{staticClass:"white--text"},[_vm._v(" "+_vm._s(_vm.number)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }